<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" @click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Generar Envíos</a>
  </div>
  <h1 class="ui header"><img class="ui image" src="../assets/parcels.png">
    <div class="content">Generar Envíos</div>
  </h1>
  <div class="ui tabular menu">
    <div class="item active" @click="goTo('/generateParcel')">
      Generar un envío manualmente
    </div>
    <div class="item " @click="goTo('/importParcels')">
      Importar fichero
    </div>
  </div>
  <div v-if="!apmOptions" class="ui active centered inline loader"></div>
  <div v-if="apmOptions" class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <h4 class="ui dividing header">Datos del paquete</h4>
        <form class="ui form" @submit.prevent="confirmParcel">
          <div class="field">
            <label>Taquilla de destino</label>
            <sui-dropdown :options="apmOptions" placeholder="Taquilla" selection v-model="parcelInfo.place_id" required/>
          </div>

          <div class="two fields" v-if="ext ==='nacex'">
            <div class="field">
              <label>Número de pedido</label>
              <input type="text" v-model="parcelInfo.barcode_alt" placeholder="Código de barras" :required="isLeroyMerlin">
            </div>
            <div class="field">
              <label>Número de albarán</label>
              <input type="text" v-model="parcelInfo.refcode" placeholder="Número de albarán" :required="isLeroyMerlin">
            </div>
          </div>

          <div class="field" v-if="ext !=='nacex'">
            <label v-if="ext ==='nacex'">Número de pedido</label>
            <label v-else-if="isLeroyMerlin">Código de barras (Escanear en pantalla) *</label>
            <label v-else>Código de barras (Escanear en pantalla)</label>
            <input type="text" v-model="parcelInfo.barcode_alt" placeholder="Código de barras" :required="isLeroyMerlin">
          </div>
          <div class="field" v-if="ext!=='nacex'">
            <label>Nombre *</label>
            <input type="text" v-model="parcelInfo.name" placeholder="Nombre" required>
          </div>
          <div class="two fields">
            <div class="field">
              <label>Teléfono</label>
              <input type="number" v-model="parcelInfo.phone" placeholder="Teléfono">
            </div>
            <div class="field">
              <label>Email</label>
              <input type="email" v-model="parcelInfo.email" placeholder="Email">
            </div>
          </div>
          <div class="field" v-if="ext=='nacex'">
            <label>Agencia</label>
            <input type="text" v-model="parcelInfo.agencia" placeholder="Agencia">
          </div>
          <div class="two fields" v-if="ext!=='nacex'">
            <div class="field" v-if="parcelSizes">
              <label>Tamaño del paquete</label>
              <sui-dropdown :options="parcelSizes" selection v-model="parcelInfo.packageStandardSize" />
            </div>
            <div class="field">
              <label v-if="isLeroyMerlin">Código de tienda *</label>
              <label v-else>Código de referencia</label>
              <input type="text" v-model="parcelInfo.refcode" :placeholder="[[ placeholder_ref ]]" :required="isLeroyMerlin">
            </div>
            <div class="field">
              <label>* Campos obligatorios</label>
            </div>
          </div>

          <button id="generate" class="ui button fluid" type="submit">Generar Envío</button>
        </form>
      </div>
      <div class="column">
        <div v-if="msg_error" class="ui warning message"> 
          <h4 class="ui dividing header">Error</h4>
            <p v-if="msg_error"> {{ msg_error }} </p>
        </div> 
        <div v-if="barcodeImage" class="ui form">
          <div  class="field">
            <label>Código para escanear</label>
            <barcode class='erdian' v-bind:value="barcodeImage" width="2">
              Show this if the rendering fails.
            </barcode>
          </div>
        </div>
        <div v-if='gpResponse' class="ui segment">
          <a class="ui orange ribbon label">response</a>
          <p></p>
          <pre>
            {{gpResponse}}
        </pre>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
import VueBarcode from 'vue-barcode';
export default {
  name: 'GenerateParcel',
  data() {
    return {
      user: null,
      pass: null,
      role: null,
      ext: null,
      isLeroyMerlin: false,
      placeholder_ref: 'Referencia',
      barcodeImage: null,
      apmOptions: null,
      gpResponse: null,
      msg_error: null,
      parcelInfo: {
        place_id: null,
        name: null,
        phone: null,
        email: null,
        barcode_alt: null,
        refcode: null,
        packageStandardSize: 'XS',
        agencia: null, 
      },
      parcelSizes: []
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role
    this.role = role
    this.ext = JSON.parse(localStorage.company).ext
    if (role === 'master' || (role.includes('apiclient') && this.ext !== 'nacex')  || role === 'staffappmediamarkt') {
      this.getUsersApms()
      this.getCredentials_v2();
      this.getSizes()
    } else if (this.ext === 'nacex') {
      this.isLeroyMerlin = true
      this.getUsersApms()
      this.getSizes()
    } else {
      this.$router.replace('/parcels_v2')
    }
    let company = JSON.parse(localStorage.company).name
    if (company === 'Leroy Merlin') {
      this.isLeroyMerlin = true
      this.placeholder_ref = 'Tienda'
    }
  },
  methods: {
    getSizes() {
      this.axios.get("static/sizes.json").then(response => {
        let sizes = response.data.parcelSizes;
        this.parcelSizes = sizes.map((e) => {
          return {
            text: e.text,
            key: e.key,
            value: e.value,
          }
        })
      })
      .catch((request) => console.log('error getting stock types: ' . request));
    },
    async getUsersApms() {
      await hapiickApi().post('/v1/users/apms', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(req => {
        let apmsList = JSON.parse(JSON.stringify(req.data.data.apms))
        let resultApm = []
        for (let i = 0; i < apmsList.length; i++) {
          resultApm.push({
            key: apmsList[i].Apt.place_id,
            text: apmsList[i].LanguagesApts[0].name,
            value: apmsList[i].Apt.place_id
          })
        }
        this.apmOptions = resultApm;
        this.parcelInfo.place_id = resultApm[0].key
      })
      .catch((req) => console.log('error getting apms: ' + req))
    },
    goTo(where) {
      this.$router.push(where)
    },
    confirmParcel() {
      if (this.ext === 'nacex') {
        if (!this.validateData()) {
          x = document.getElementById("generate")
          x.classList.remove("loading");
          x.disabled = false;
          return
        }
      }

      this.msg_error = null
      this.$swal
        .fire({
          title: 'Se va a generar el envío',
          text: 'Por favor, confirma esta acción o cancela si no estás seguro/a',
          type: 'question',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Confirmar'
        })
        .then((result) => {
          if (result.value) {
            this.generateParcel()
            }
        })
    },
    validateData(){
      if (!this.parcelInfo.barcode_alt) {
        this.$swal.fire({
          type: 'info',
          text: 'Obligatorio introducir número de pedido',
        })
        return false
      }
      if (!this.parcelInfo.email && !this.parcelInfo.phone) {
        this.$swal.fire({
          type: 'info',
          text: 'Obligatorio introducir número de movil o email',
        })
        return false
      }
      if (!this.parcelInfo.agencia) {
        this.$swal.fire({
          type: 'info',
          text: 'Obligatorio introducir número de agencia',
        })
        return false
      }
      
      return true
    },
    generateParcel() {
      let url;
      let x = document.getElementById("generate");
      x.classList.add("loading");
      x.disabled = true;

      let body = {
        admin_id: JSON.parse(localStorage.admin).id,
        place_id: this.parcelInfo.place_id,
        phone: this.parcelInfo.phone,
        email: this.parcelInfo.email,
        barcode_alt: this.parcelInfo.barcode_alt,
        refcode: this.parcelInfo.refcode
      }

      if ((this.role.includes('apiclient') && this.ext !== 'nacex')) {
        url = '/webservices/new_client_shipment';
        body.name = this.parcelInfo.name
        //body.refcode = this.parcelInfo.refcode
        body.packageStandardSize = this.parcelInfo.packageStandardSize
      } else if (this.role.includes('staffappmediamarkt')) {
        url = '/webservices/v1/new_mediamarkt_shipment';
        body.name = this.parcelInfo.name
        //body.refcode = this.parcelInfo.refcode
        body.packageStandardSize = this.parcelInfo.packageStandardSize
      } else if (this.ext === 'nacex') {
        url = '/v1/users/shipments/add'
/*         if (!this.validateData()) {
          x = document.getElementById("generate")
          x.classList.remove("loading");
          x.disabled = false;
          return
        } */

        body.key = this.ext
        body.slot_size = this.parcelInfo.packageStandardSize
        body.agencia = this.parcelInfo.agencia
      }

      hapiickApi().post(url, {
        admin_id: JSON.parse(localStorage.admin).id,
        parcelInfo: body
      })
      .then(request => {
        this.showResponse(request)
      })
      .catch((request) => {
        console.log('error generating parcel: ' + request)
        this.msg_error = "Se ha producido un error al generar el envío. Vuelve a iniciar sesión y prueba de nuevo."
      })
    },
    getCredentials_v2() {
      hapiickApi().post('/v2/clients/get-credentials', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then(request => this.setCredentials_v2(request))
      .catch(() => console.log('error getting credentials'))
    },
    setCredentials_v2(req) {
      this.pass = JSON.parse(JSON.stringify(req.data.data.password))
      this.user = JSON.parse(JSON.stringify(req.data.data.username))
    },
    showResponse(req) {
      const { status, error, shipment } = req.data
      if (error) {
        if (error === 'Provider api error') {
          this.msg_error = 'Error desconocido'
        } else if (error === 'Duplicated barcode') {
          this.msg_error = 'Pedido duplicado'
        } else {
          this.msg_error = error
        }
      } else {
        this.barcodeImage = JSON.parse(JSON.stringify(shipment.barcode))
      }

      let x = document.getElementById("generate")
      x.classList.remove("loading");
      x.disabled = false;

      Object.keys(this.parcelInfo).forEach(key => {
        this.parcelInfo[key] = (key === 'packageStandardSize') ? 'XS' : null;
      });
    }
  },
  components: {
    'barcode': VueBarcode
  }
}
</script>
<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
}

input[type=number] { 
  -moz-appearance: textfield;
  appearance: textfield;
}

.erdian {
  border-style: solid;
  border-radius: 0.1px;
  border-color: var(--var-color);
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/GenerateParcel.vue